import { render, staticRenderFns } from "./ApotFirst.vue?vue&type=template&id=8cd1643c&scoped=true&"
import script from "./ApotFirst.vue?vue&type=script&lang=js&"
export * from "./ApotFirst.vue?vue&type=script&lang=js&"
import style0 from "./ApotFirst.vue?vue&type=style&index=0&id=8cd1643c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd1643c",
  null
  
)

export default component.exports